<script>
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import { form, field, combined } from "svelte-forms";
	import { navigate } from "svelte-routing";
	import {
		errorMessage,
		loading,
		totalPages,
		loadingStatus,
		vehicleEditData,
	} from "../../../../store/store";
	import client from "../../../../services/client";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import { required } from "svelte-forms/validators";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";

	let idCarParkOwner = window.location.pathname.split(
		"master-data/vehicle-data/carpark-owner/edit/"
	)[1];
	export let recordId;
	let data = [];
	let carParkOwnerError;
	const carParkOwner = field("carParkOwner", $vehicleEditData.name, [
		required(),
	]);
	const myForm = form(carParkOwner);
	let load = false;
	const handleSubmit = async () => {
		try {
			load = true;
			loading.set(true);
			const res = await client("/v1/carParks/owners", {
				method: "PUT",
				version: "Vehicle",
				data: {
					name: $carParkOwner.value,
					id: recordId,
				},
			});

			if (res?.status === 200) {
				navigate("/master-data/vehicle-data/carpark-owner");
			} else {
				loading.set(false);
				carParkOwnerError = res.data.message;
			}

			load = false;
			loading.set(false);
		} catch (error) {
			console.log(error);
			load = false;
			carParkOwnerError = error.response.data.message;
			loading.set(false);
		}
	};
</script>

<Row>
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="Vehicle Carpark Owner Data" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Edit Carpark Owner Name</b></h5>
			</div>
			<div>
				<p>*Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="mobile" class="d-block">
						<span>Carpark owner Name* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomInput
						type="text"
						bind:value={$carParkOwner.value}
						error={$myForm.hasError("carParkOwner.required") ||
							carParkOwnerError}
						errorText={$myForm.hasError("carParkOwner.required")
							? "Carpark owner name is required"
							: carParkOwnerError
								? carParkOwnerError
								: ""}
					/>
				</Col>
				<Col class="d-flex justify-content-start" xs={6}>
					<div class="mx-4 my-1">
						<Button
							class="themeButton primary px-2"
							block
							disabled={!$myForm.valid || !$carParkOwner.value}
							on:click={myForm.validate}
							on:click={() => handleSubmit()}
						>
							{#if load}
								<Loader />
							{:else}
								Edit
							{/if}
						</Button>
					</div>
				</Col>
			</Row>
		</Col>
	</Col>
</Row>
